module.exports = "<app-loader *ngIf=\"isLoading\"></app-loader>\r\n<select *ngIf=\"!showAsLabel\"\r\n\tclass=\"w3-select w3-block w3-border w3-round\"\r\n\t[(ngModel)]=\"value\"\r\n\t[disabled]=\"isDisabled\">\r\n\t<option [value]=\"null\">Select container</option>\r\n\t<option *ngFor=\"let c of options\" [value]=\"c.key\">\r\n\t\t{{c.value}}\r\n\t</option>\r\n</select>\r\n\r\n<label *ngIf=\"showAsLabel\">{{getLabel()}}</label>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-container-select/ztsi-container-select.component.html
// module id = ./src/app/components/shared/ztsi-container-select/ztsi-container-select.component.html
// module chunks = main